import * as SwitchPrimitive from "@radix-ui/react-switch";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

export type SwitchProps = Omit<ComponentProps<typeof SwitchPrimitive.Root>, "asChild" | "children">;

/** Radix Switch rendered as the token `.switch`: a 36x24 button (WCAG 2.5.8) whose 36x20 track is `::before` and thumb `::after`, state via aria-checked. */
export function Switch({ className, ...rest }: SwitchProps) {
  return <SwitchPrimitive.Root className={cn("switch disabled:cursor-not-allowed disabled:opacity-50", className)} {...rest} />;
}
